import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./context/auth-provider";
import ScrollToTop from "./components/scroll-to-top";


function App() {
  return (
    <AuthProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <AppRoutes />
        </BrowserRouter>
      </I18nextProvider>
    </AuthProvider>
  );
}

export default App;
